export default __webpack_public_path__ + "media/images/features/ana/example_image_sp-fdbfcc004166e71ed7815b12d19b5e1d.png";